var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"senansbtn_wrapper"},[_c('b-button',{on:{"click":function($event){return _vm.appendAnswer()}}},[_vm._v("정답추가(+)")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }